import { Injectable } from '@angular/core';
import { UrlService } from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from '../core/dc-base.requester';
import { IDataLinkContactRequest } from './email-sender.model';

@Injectable({
	providedIn: 'root',
})
export class EmailSenderRequester extends DcBaseRequester<void> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('REPOSITORY_DATALINK_CONTACT');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public contactDataLinkEditors(
		repositoryId: number,
		message: { subject: string; body: string }
	): Observable<void> {
		const url = this.urlService.generateUrl(
			this.resource,
			{
				repositoryId,
			},
			{
				project: this.projectId,
			}
		);

		const payload: IDataLinkContactRequest = {
			subject: message.subject,
			message: message.body,
		};

		return this.http.post<void>(url, payload);
	}
}
